import {
  IResearchSummary,
  IResearchSummaryFilters,
} from "features/Research/types";
import { apiClient } from "lib/apiClient";

export const getResearchSummary = async (
  filters: IResearchSummaryFilters = {}
): Promise<IResearchSummary> => {
  const response = await apiClient.get("/research/summary", {
    params: filters,
  });

  return response.data;
};
